/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentNoteText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Author from './Author/index'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppointmentNoteText({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/AppointmentNotes/Content/AppointmentNoteText"
  
}) {
let noteNoteValueData = fromData.useDataValue({ viewPath,
context: 'note',
path: 'note',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<Author
  viewPath={`${viewPath}/Author`}
/>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 fontSize={dtTypographyFontsizeM}
 lineHeight={16}
 data="note.note"
 html={noteNoteValueData}
/>
{children}
</React.Fragment>)
}